import { render, staticRenderFns } from "./ReportPmtaTrouble.vue?vue&type=template&id=be512476&scoped=true"
import script from "./ReportPmtaTrouble.vue?vue&type=script&lang=js"
export * from "./ReportPmtaTrouble.vue?vue&type=script&lang=js"
import style0 from "./ReportPmtaTrouble.vue?vue&type=style&index=0&id=be512476&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be512476",
  null
  
)

export default component.exports